<template>
  <div class="navbar">
    <div class="right-menu spaceLeft">
      <metaMaskInit/>
      <svg-icon class="right-menu_svg" icon-class="tn-logout" @click="logout"/>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Breadcrumb from "@/components/Breadcrumb";
import Hamburger from "@/components/Hamburger";
import Screenfull from "@/components/Screenfull";
import SizeSelect from "@/components/SizeSelect";
import Search from "@/components/HeaderSearch";
import metaMaskInit from "./metaMaskInit/index.vue"
export default {
  components: {
    Breadcrumb,
    Hamburger,
    Screenfull,
    SizeSelect,
    Search,
    metaMaskInit
  },
  computed: {
    ...mapGetters(["sidebar", "avatar", "device", "userInfo"]),
    setting: {
      get() {
        return this.$store.state.settings.showSettings;
      },
      set(val) {
        this.$store.dispatch("settings/changeSetting", {
          key: "showSettings",
          value: val
        });
      }
    }
  },
  methods: {
    toggleSideBar() {
      this.$store.dispatch("app/toggleSideBar");
    },
    async logout() {
      this.$confirm("Are you sure you want to log out and exit?", "Tips", {
        confirmButtonText: "Yes",
        cancelButtonText: "No",
        type: "warning"
      }).then(() => {
        this.$store.dispatch("SetRole", 0)
        // console.log('state.role', this.$store.state.user.role)
        this.$store.dispatch("LogOut").then(() => {
          // console.log('state.role', this.$store.state.user.role)
          location.reload();
        });
      });
    },
    getUserName(){
      if(this.$store.getters.userInfo.type == 1){ //AUDIT MANAGER
        return process.env.VUE_APP_AUDIT_MANAGER;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.navbar {
  height: 0.64rem;
  overflow: hidden;
  position: relative;
  background: #ffffff;
  // box-shadow: 0 1px 4px rgba(0, 21, 41, 0.08);
  color: #6B6B6B;
  .hamburger-container {
    line-height: 0.46rem;
    height: 100%;
    float: left;
    cursor: pointer;
    transition: background 0.3s;
    -webkit-tap-highlight-color: transparent;

    &:hover {
      background: rgba(0, 0, 0, 0.025);
    }
  }

  .breadcrumb-container {
    float: left;
  }

  .errLog-container {
    display: inline-block;
    vertical-align: top;
  }

  .right-menu {
    float: right;
    height: 100%;
    // line-height: 50px;


    .right-menu_account,
    .right-menu_svg {
      font-size: 0.18rem;
      margin-right: 0.32rem;
      // color:#C8D4EF;
    }
    .right-menu_svg {
      cursor: pointer;
      color: #ABB6C0;
    }

    &:focus {
      outline: none;
    }

    // .right-menu-item {
    //   display: inline-block;
    //   padding: 0 8px;
    //   height: 100%;
    //   font-size: 18px;
    //   color: #5a5e66;
    //   vertical-align: text-bottom;

    //   &.hover-effect {
    //     cursor: pointer;
    //     transition: background 0.3s;

    //     &:hover {
    //       background: rgba(0, 0, 0, 0.025);
    //     }
    //   }
    // }

    // .avatar-container {
    //   margin-right: 30px;

    //   .avatar-wrapper {
    //     margin-top: 5px;
    //     position: relative;

    //     .user-avatar {
    //       cursor: pointer;
    //       width: 40px;
    //       height: 40px;
    //       border-radius: 10px;
    //     }

    //     .el-icon-caret-bottom {
    //       cursor: pointer;
    //       position: absolute;
    //       right: -20px;
    //       top: 25px;
    //       font-size: 12px;
    //     }
    //   }
    // }
  }
}

.badge-box{
  position: relative;
  .badge{
    position: absolute;
    right: -8px;
    top:10px;
    width: 9px;
    height: 9px;
    background: #FF2020;
    border-radius: 100%;
  }
}
</style>
